// German for the MOMENTUM zone: the weekly strip, its legend and the three figures.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Momentum': 'Momentum',
  'weekly contact since {date}': 'wöchentlicher Kontakt seit {date}',
  'no dated evidence': 'keine datierten Belege',
  'The strip appears once there are 5 touches over 8 weeks.': 'Der Streifen erscheint, sobald 5 Kontakte über 8 Wochen vorliegen.',
  '{date} · {docs} documents, {events} events': '{date} · {docs} Dokumente, {events} Ereignisse',
  '{n} weeks': '{n} Wochen',
  'bar height = documents + events that week': 'Balkenhöhe = Dokumente + Ereignisse der Woche',
  '{n} days of contact': '{n} Kontakttage',
  'days since last contact': 'Tage seit dem letzten Kontakt',
  'longest silence, in days': 'längste Funkstille, in Tagen',
  'events on the record': 'Ereignisse im Protokoll',
}, 'ClientMomentum');
